const initialState = {
  isRequested: false,
  selectedCinema: 0,
  selectedWeek: null,
  selectedDate: '',
  selectedView: 'tile',
  searchField: '',
  filteredMovies: [],
  timeList: ['8-9', '10-11', '12-13', '14-15', '16-17', '18-19', '20-21', '22-06'],
  cinemaDays: ['Csütörtök', 'Péntek', 'Szombat', 'Vasárnap', 'Hétfő', 'Kedd', 'Szerda'],
  dates: null,
  weeks: null,
  cinemas: null,
  weeksDetails: [],
  movies: [],
  realTableData: [],
  activeModal: {
    title: null,
    index: null,
  },
  currentTime: null,
  brand: null,
  brandClass: null,
};

export default initialState;
